
import { useSelector  } from 'react-redux';

import { getDatawin } from '../reducers'
import { getFetchAttributes } from '../reducers/datawin'

export default function useDatawinFetchAttributes(dataModelItemId) {
    const datawin = useSelector(state => getDatawin(state.data));
    return getFetchAttributes(datawin, dataModelItemId);
}
